<template lang="pug">
  table.cart-totals-table
    tr
      th Subtotal
      td {{ totalPrice | money }}
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'CartTotalsTable',
    computed: {
      ...mapState({
        itemsSubtotal: (state) => state.cart.items_subtotal_price,
        totalDiscount: (state) => state.cart.total_discount,
        totalPrice: (state) => state.cart.total_price,
      }),
    },
  };
</script>

<style scoped lang="scss">
  .cart-totals-table {
    padding-bottom: $spacing-unit * 4;
    width: 100%;
  }

  th {
    font-weight: $font-weight-regular;
    text-align: left;
  }

  td {
    text-align: right;
  }
</style>
